import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const userPlaylistImporterSelectors = importerSelectors(
  'userPlaylist.importer',
)

export default userPlaylistImporterSelectors
